'use strict';

var VASTClient = require('../ads/vast/VASTClient');
var VASTError = require('../ads/vast/VASTError');
var vastUtil = require('../ads/vast/vastUtil');

var VASTIntegrator = require('../ads/vast/VASTIntegrator');
var VPAIDIntegrator = require('../ads/vpaid/VPAIDIntegrator');
var YandexIntegrator = require('../ads/yandex/yandex-integrator');

var async = require('../utils/async');
var dom = require('../utils/dom');
var playerUtils = require('../utils/playerUtils');
var utilities = require('../utils/utilityFunctions');
var puids = require('../utils/puids');

var logger = require ('../utils/consoleLogger');

module.exports = function VASTPlugin(options) {
  var player = this;
  var vast = new VASTClient();
  var adsCanceled = false;
  var defaultOpts = {
    // maximum amount of time in ms to wait to receive `adsready` from the ad
    // implementation after play has been requested. Ad implementations are
    // expected to load any dynamic libraries and make any requests to determine
    // ad policies for a video during this time.
    timeout: 500,

    //TODO:finish this IOS FIX
    //Whenever you play an add on IOS, the native player kicks in and we loose control of it. On very heavy pages the 'play' event
    // May occur after the video content has already started. This is wrong if you want to play a preroll ad that needs to happen before the user
    // starts watching the content. To prevent this usec
    iosPrerollCancelTimeout: 2000,

    // maximun amount of time for the ad to actually start playing. If this timeout gets
    // triggered the ads will be cancelled
    adCancelTimeout: 3000,

    // Boolean flag that configures the player to play a new ad before the user sees the video again
    // the current video
    playAdAlways: false,

    // Flag to enable or disable the ads by default.
    adsEnabled: true,

    // Boolean flag to enable or disable the resize with window.resize or orientationchange
    autoResize: true,

    // Boolean flag to run flash support check
    flashSupportCheck: true,

    // Path to the VPAID flash ad's loader
    vpaidFlashLoaderPath: '/VPAIDFlash.swf',

    // Path to PlayToggle btn to set pause roll
    playComponentPath: 'controlBar playToggle',

    // List of advert-xml links
    advertUrls: {},

    // Placeholders for puids in advert urls
    puids: {
      // Aliases for placeholder types 
      // Supported types: url, duration_type, player_size_type, fullscreen

      // Placeholder format: type: {
      //   name: '', 
      //   rule: function() {}
      // }
      placeholders: { 
          url: {},
          duration_type: {},
          player_size_type: {},
          fullscreen: {},
          rnd: {}
      },

      prefix: '$',
      postfix: ''
    },


    ga: {
      id: 'UA-54153550-5',
      client: '',
      userId: '',
      enabled: true
    },

    usePods: false,  

    // verbosity of console logging:
    // 0 - error
    // 1 - error, warn
    // 2 - error, warn, info
    // 3 - error, warn, info, log
    // 4 - error, warn, info, log, debug
    verbosity: 0
  };

  var settings = utilities.extend({}, defaultOpts, options || {});

  var counterComponent;
  if (settings.isCounter) {
    videojs.registerComponent('VastVpaidCounter', videojs.getComponent('Component'));
    counterComponent = player.addChild('VastVpaidCounter');
    counterComponent.hide();
    counterComponent.addClass('vjs-vast-vpaid-counter');
    if (videojs.browser.IS_IPAD) {
      counterComponent.addClass('vjs-vast-vpaid-counter_ipad');
    }
  }

  if(utilities.isUndefined(settings.adTagUrl) && utilities.isDefined(settings.url)){
    settings.adTagUrl = settings.url;
  }

  if (utilities.isString(settings.adTagUrl)) {
    settings.adTagUrl = utilities.echoFn(settings.adTagUrl);
  }

  if (utilities.isDefined(settings.adTagXML) && !utilities.isFunction(settings.adTagXML)) {
    return trackAdError(new VASTError('on VideoJS VAST plugin, the passed adTagXML option does not contain a function'));
  }

  if (!utilities.isDefined(settings.adTagUrl) && !utilities.isFunction(settings.adTagXML) && !utilities.isDefined(settings.advertUrls)) {
    return trackAdError(new VASTError('on VideoJS VAST plugin, missing adTagUrl on options object'));
  }

  settings.advertUrls = settings.advertUrls || {};
  settings.midrollPoints = settings.midrollPoints || {};

  logger.setVerbosity (settings.verbosity);

  if (settings.flashSupportCheck) {
    vastUtil.runFlashSupportCheck(settings.vpaidFlashLoaderPath);// Necessary step for VPAIDFLASHClient to work.
  }

  if (settings.ga.enabled) {
    vastUtil.initGaStat(settings.ga, player);
  }

  player.on('vast.firstPlay', tryToPlayAd);
  player.on('vast.postrollPlay', tryToPlayAd);
  player.on('vast.pauserollPlay', tryToPlayAd);
  player.on('vast.midrollPlay', tryToPlayAd);
  player.on(['vast.adsCancel', 'vast.error', 'vpaid.AdError', 'vast.adBlockStart'], runSpinner);

  if (counterComponent) {
    player.on('vast.adStart', () => {
      var total = player.vast.advertUrls[player.vast.curAd.type].length;
      var isAdPlayLimit = typeof settings.adPlayLimit === 'number' && !isNaN(settings.adPlayLimit);
      if (isAdPlayLimit && total > settings.adPlayLimit) {
        total = settings.adPlayLimit;
      }
      counterComponent.el().innerText = `Реклама ${player.vast.curAd.playedAd + 1} из ${total}`;
      counterComponent.show();
    });
    player.on('vast.adEnd', () => {
      counterComponent.hide();
    });
  }

  player.on('vast.reset', function () {
    //If we are reseting the plugin, we don't want to restore the content
    player.vast.curAd.snapshot = null;
    initMidrollPoints();
    cancelAds();
  });

  player.on('vast.adResponseEndWithErr', function() {
    player.trigger('vast.adNotProvided');
  });

  player.on('vast.adNoInParams', function() {
    player.trigger('vast.adNotProvided');
  });

  player.vast = {
    isEnabled: function () {
      return settings.adsEnabled;
    },

    enable: function () {
      settings.adsEnabled = true;
    },

    disable: function () {
      settings.adsEnabled = false;
    },

    isAdPlaying: function () {
      return player.vast && player.vast.adUnit;
    },

    playComponentPath: settings.playComponentPath,

    advertUrls: videojs.mergeOptions({}, settings.advertUrls),
    ga: settings.ga,
    usePods: settings.usePods

  };

  initMidrollPoints();

  playerUtils.prepareForAds(player);

  return player.vast;

  function tryToPlayAd() {

    player.hotkeys_disable = true;
    player.vast.curAd.playedAd = 0;

    // disable player.handleTechError
    player.off(player.tech_, 'error', player.handleTechError_);
    player.on(player.tech_, 'error', handleTechError);

    // Actions for all ad block
    playerUtils.once(player, ['vast.adBlockEnd'], function () {
      // enable player.handleTechError
      player.on(player.tech_, 'error', player.handleTechError_);
      player.off(player.tech_, 'error', handleTechError);

      restoreVideoContent();

      if (player.vast.curAd.type == 'post_roll') {
        if (settings.playAdAlways) player.trigger('vast.reset');
        player.trigger('vast.lastPostrollEnd');
      }
      player.trigger('vast.adBlockReset');

      player.hotkeys_disable = false;
    });

    setAdvertUrls();

    if (!hasAdvert()) {
      cancelAds();
      player.trigger('vast.adNoInParams');
      player.trigger('vast.adBlockEnd');
      return;
    }

    //We remove the poster to prevent flickering whenever the content starts playing
    playerUtils.removeNativePoster(player);

    async.waterfall([
      checkAdsEnabled, 
      preparePlayerForAd,
      prepareBlockPuids
    ], function (error, response) {
      if (error) {
        trackAdError(error, response);
      } else {
        playOneAd();
      }
    });

    /*** Local functions ***/

    // Actions for one ad in ad block
    function handleTechError() {
      // on video error try to play next advert
      cancelAds();
      tryToPlayNextInBlock();
    }

    function playOneAd() {

      playerUtils.once(player, ['vast.adsCancel', 'vast.adEnd'], function () {
        player.trigger('vast.adFinish');
        player.setTimeout(removeAdUnit, 0);
      });

      async.waterfall([
        setCurAdUrl,
        addSpinnerIcon,
        startAdCancelTimeout,
        playTypeAd
      ], function (error, response) {
        if (error) {
          trackAdError(error, response);
          if (error.code == "EMPTY_AD" || error.code == 303) {
            error = null;
          }
        } else {
          player.trigger('vast.adEnd');
        }
        tryToPlayNextInBlock(error);
      });
    }

    function setAdvertUrls(){
      var type = player.vast.curAd.type;
      if (!settings.advertUrls[type]) {
        player.vast.advertUrls[type] = [];
      } else {
        var urls = utilities.processVal(settings.advertUrls[type], {type: type}, player);
        player.vast.advertUrls[type] = utilities.isArray(urls) ? urls : [urls];
      }
    }

    function hasAdvert(){
      return player.vast.curAd && player.vast.advertUrls[player.vast.curAd.type] && player.vast.advertUrls[player.vast.curAd.type].length || settings.adTagUrl; // TODO setCurAdUrl before? check by url 
    }

    function setCurAdUrl(next){
      if (!player.vast.curAd) return;
      if (!player.vast.advertUrls[player.vast.curAd.type]) return;
      player.vast.curAd.url = player.vast.advertUrls[player.vast.curAd.type][player.vast.curAd.counter];
      if (!player.vast.curAd.url) player.vast.curAd.url = settings.adTagUrl ? settings.adTagUrl() : settings.adTagXML;
      next(null);
    }

    function tryToPlayNextInBlock(error) {
      if (!player.vast.curAd) return;

      // try next in pod TODO own method 
      if (hasNextInPod()) {
        playOneAd();
        return;
      } else {
        player.vast.ads = null;
        if (player.vast.usePods) player.trigger('vast.adPodBlockEnd');
      }

      player.vast.curAd.counter++; 
      if (hasNextInBlock() && (!settings.tryPlayAd && error || settings.tryPlayAd) && !limitExceeded()) {
        playOneAd();
      } else {
        player.trigger('vast.adBlockEnd');
      }
    }

    function hasNextInBlock() {
      return player.vast.curAd.counter < (player.vast.advertUrls[player.vast.curAd.type] && player.vast.advertUrls[player.vast.curAd.type].length);
    }

    function limitExceeded() {
      if (!settings.adPlayLimit || !player.vast.curAd) {
        return false;
      }
      return player.vast.curAd.playedAd >= settings.adPlayLimit;
    }

    function removeAdUnit() {
      if (player.vast && player.vast.adUnit) {
        player.vast.adUnit = null; //We remove the adUnit
      }
    }

    function restoreVideoContent() {
      setupContentEvents();
      removeAdUnit();
      if (player.vast.curAd.snapshot) {
        playerUtils.restorePlayerSnapshot(player, player.vast.curAd.snapshot);
        player.vast.curAd.snapshot = null;
      }
    }

    function setupContentEvents() {
      var type = player.vast.curAd.type;
        playerUtils.once(player, ['playing', 'vast.reset', 'vast.firstPlay', 'vast.postrollPlay', 'vast.pauserollPlay', 'vast.midrollPlay'], function (evt) { 
          if (evt.type !== 'playing') {
            return;
          }
          player.trigger('vast.contentStart');

          playerUtils.once(player, ['ended', 'vast.reset', 'vast.firstPlay', 'vast.postrollPlay', 'vast.pauserollPlay', 'vast.midrollPlay'], function (evt) {
            if (evt.type === 'ended') {
              player.trigger('vast.contentEnd');
            }
          });
        });
    }

    function checkAdsEnabled(next) {
      if (settings.adsEnabled) {
        return next(null);
      }
      next(new VASTError('Ads are not enabled'));
    }

    function preparePlayerForAd(next) {
      if (canPlayAd()) {
        player.vast.curAd.snapshot = playerUtils.getPlayerSnapshot(player);
        player.pause();

        if(player.paused()) {
          next(null);
        } else {
          playerUtils.once(player, ['playing'], function() {
            player.pause();
            next(null);
          });
        }
      } else {
        next(new VASTError('video content has been playing before preroll ad'));
      }
    }

    function canPlayAd() {
      if (player.vast.curAd && player.vast.curAd.type == 'pre_roll') {
        return !utilities.isIPhone() || player.currentTime() <= settings.iosPrerollCancelTimeout;
      }
      return true;
    }

    function prepareBlockPuids(next) {
      puids.generateRnd(player.vast.curAd.type);
      next(null);
    }

    function startAdCancelTimeout(next) {
      var adCancelTimeoutId;
      adsCanceled = false;

      // off - inactive tab may exceed Timeouts
      /*adCancelTimeoutId = setTimeout(function () {
        trackAdError(new VASTError('timeout while waiting for the video to start playing', 402));
        tryToPlayNextInBlock(); // restore video but miss 2+ adverts in block stat (xhr was made but video doesn't start async on inactive tab)
      }, settings.adCancelTimeout);*/

      playerUtils.once(player, ['vast.adStart', 'vast.adsCancel'], clearAdCancelTimeout);

      /*** local functions ***/
      function clearAdCancelTimeout() {
        if (adCancelTimeoutId) {
          clearTimeout(adCancelTimeoutId);
          adCancelTimeoutId = null;
        }
      }

      next(null);
    }

    function addSpinnerIcon(next) {
      if (!adsCanceled) {
        dom.addClass(player.el(), 'vjs-vast-ad-loading');
        playerUtils.once(player, ['vast.adStart', 'vast.adsCancel'], removeSpinnerIcon);
      }
      next(null);
    }

    function removeSpinnerIcon() {
      //IMPORTANT NOTE: We remove the spinnerIcon asynchronously to give time to the browser to start the video.
      // If we remove it synchronously we see a flash of the content video before the ad starts playing.
      setTimeout(function () {
        dom.removeClass(player.el(), 'vjs-vast-ad-loading');
      }, 100);
    }
  }

  function cancelAds() {
    player.trigger('vast.adsCancel');
    if (!player.vast.curAd.snapshot  && !player.paused() && 
      (player.vast.curAd.type === 'pre_roll' ||
      player.vast.curAd.type === 'pause_roll')) { // if was no try to play ad
      player.trigger('vast.contentPlay');
    }
    adsCanceled = true;
  }

  function playTypeAd(callback) {

    if (needDelay()) {
      setTimeout(function(){
        proceedPlayTypeAd();
      }, 300);
    } else {
      proceedPlayTypeAd();
    }

    function proceedPlayTypeAd() {
      async.waterfall([
        replaceAdvertPuids,
        getVastResponse, 
        playAd
      ], callback);
    }

    function needDelay() { // for EME another request in process fix
      return player.tech_.currentSource_ && player.tech_.currentSource_.keySystemOptions &&
        player.vast.curAd.type == "pre_roll";
    }
  }

  function hasNextInPod() {
    return player.vast.usePods && player.vast.ads && (player.vast.ads.pods || []).length;
  }

  function replaceAdvertPuids(next) {
    if (!player.vast.curAd) return;
    var puidsList = settings.puids,
        p = player.vast.curAd.point;
    if (player.vast.curAd.type == "mid_roll") {
      puidsList.placeholders = utilities.extend({}, puidsList.placeholders, (settings.midrollPoints[p] || {}).placeholders);
    };
    player.vast.curAd.puidsList = puidsList;
    player.vast.curAd.url = puids.getProcessedUrl(player, player.vast.curAd.url, puidsList);
    return next(null);
  }

  function getVastResponse(callback) {
    if (!player.vast.curAd) return;
    var d;

    if (hasNextInPod()) {
      d = player.vast.ads;
    } else {
      d = player.vast.curAd.url;
      player.vast.ads = null;
      if (player.vast.usePods) {
        player.trigger('vast.adPodBlockStart');
      } 
    }

    if (d && typeof d.startsWith === 'function' && d.startsWith('yandex-ads')) {
      var yandexResponse = {
        integrator: 'yandex',
        type: player.vast.curAd.type,
        name: d
      };
      callback && callback(null, yandexResponse);
    } else {
      vast.getVASTResponse(d, player.vast.usePods, function(err, response, ads){
        player.trigger('vast.adResponseEnd', {response: response, err: err});
        err ?  player.trigger('vast.adResponseEndWithErr', err) : player.trigger('vast.adResponseEndNoErr');
        if (err && (err.code == 303 || err.code == 'EMPTY_AD')) {
          player.trigger('vast.noResponseAd');
        }
  
        if (ads) player.vast.ads = ads; // pod's data
        callback && callback(err, response);
      });
    }
  }

  function playAd(vastResponse, callback) {
    //TODO: Find a better way to stop the play. The 'playPrerollWaterfall' ends in an inconsistent situation
    //If the state is not 'preroll?' it means the ads were canceled therefore, we break the waterfall
    if (adsCanceled) {
      return;
    }

    var adIntegrator;
    if (vastResponse.integrator == 'yandex') {
      adIntegrator = new YandexIntegrator(player, settings);
    } else {
      adIntegrator = isVPAID(vastResponse) ? new VPAIDIntegrator(player, settings) : new VASTIntegrator(player);
    }

    var adFinished = false;
    var mainChangedComp = {};
    setSkipControlsVisibillity();

    playerUtils.once(player, ['vast.adStart', 'vast.adsCancel'], function (evt) {
      if (evt.type === 'vast.adStart') {
        player.vast.curAd.playedAd++;
        addAdsLabel();
        setAdsRemTimeControl();
        configAdsCurTimeControl();
        resetSeekingState();
      }
    });

    playerUtils.once(player, ['vast.adEnd', 'vast.adsCancel'], function(){
      removeAdsLabel();
      removeAdsRemTimeControl();
      restoreAdsCurTimeControl();
      resetSkipControlsVisibillity();
      adFinished = true;
    });

    if (utilities.isIDevice()) {
      preventManualProgress();
    }

    player.vast.vastResponse = vastResponse;

    logger.debug ("calling adIntegrator.playAd() with vastResponse:", vastResponse);
    player.vast.adUnit = adIntegrator.playAd(vastResponse, callback);

    /*** Local functions ****/
    function addAdsLabel() {
      if (adFinished || player.controlBar.getChild('AdsLabel')) {
        return;
      }

      player.controlBar.addChild('AdsLabel');
    }

    function setAdsRemTimeControl() {
      if (adFinished || player.controlBar.getChild('remainingTimeDisplay')) {
        return;
      }

      player.controlBar.addChild('remainingTimeDisplay');

      setTimeout(function () {
        var remTimeComp = player.controlBar.getChild('remainingTimeDisplay'),
            sublComp = player.controlBar && ( player.controlBar.getChild("currentTimeDisplay") 
                                                    || player.controlBar.getChild("FullscreenToggle"));
        if(sublComp && remTimeComp) {
          player.controlBar.el().insertBefore(remTimeComp.el(), sublComp.el());
        }
      }, 0);

      mainChangedComp['remainingTimeDisplay'] = 1;
    }

    function configAdsCurTimeControl() {
      var curTimeComp = player.controlBar.getChild('currentTimeDisplay');

      if (adFinished || !curTimeComp || curTimeComp && curTimeComp.el().style.display == 'none') {
        return;
      }

      curTimeComp.hide();
      mainChangedComp['currentTimeDisplay'] = 1;
    }

    function setSkipControlsVisibillity() {
      if (player.vast.curAd.forbidSkip) {
        player.addClass('vjs-forbid-skip');
      }
    }   

    function removeAdsLabel() {
      player.controlBar.removeChild('AdsLabel');
    }

    function removeAdsRemTimeControl() {
      if (adFinished || !player.controlBar.getChild('remainingTimeDisplay')) {
        return;
      }

      if (mainChangedComp['remainingTimeDisplay']) {
        player.controlBar.removeChild('remainingTimeDisplay');
      }
    }

    function restoreAdsCurTimeControl() {
      var curTimeComp = player.controlBar.getChild('currentTimeDisplay');

      if (!curTimeComp) {
        return;
      }

      if (mainChangedComp['currentTimeDisplay']) {
        curTimeComp.show();
      }
    }

    // dash does not trigger native seeked
    function resetSeekingState() {
      player.removeClass('vjs-seeking');
    }

    function resetSkipControlsVisibillity() {
      player.removeClass('vjs-forbid-skip');
    }    

    function preventManualProgress() {
      //IOS video clock is very unreliable and we need a 3 seconds threshold to ensure that the user forwarded/rewound the ad
      var PROGRESS_THRESHOLD = 3;
      var previousTime = 0;
      var skipad_attempts = 0;

      player.on('timeupdate', preventAdSeek);
      player.on('ended', preventAdSkip);

      playerUtils.once(player, ['vast.adEnd', 'vast.adsCancel', 'vast.adError'], stopPreventManualProgress);

      /*** Local functions ***/
      function preventAdSkip() {
        // Ignore ended event if the Ad time was not 'near' the end
        // and revert time to the previous 'valid' time
        if ((player.duration() - previousTime) > PROGRESS_THRESHOLD) {
          player.pause(true); // this reduce the video jitter if the IOS skip button is pressed
          player.play(true); // we need to trigger the play to put the video element back in a valid state
          player.currentTime(previousTime);
        }
      }

      function preventAdSeek() {
        var currentTime = player.currentTime();
        var progressDelta = Math.abs(currentTime - previousTime);
        if (progressDelta > PROGRESS_THRESHOLD) {
          skipad_attempts += 1;
          if (skipad_attempts >= 2) {
            player.pause(true);
          }
          player.currentTime(previousTime);
        } else {
          previousTime = currentTime;
        }
      }

      function stopPreventManualProgress() {
        player.off('timeupdate', preventAdSeek);
        player.off('ended', preventAdSkip);
      }
    }
  }

  function initMidrollPoints() {
    player.vast._midrollPointsArr = utilities.isArray(settings.midrollPoints) ? settings.midrollPoints : Object.keys(settings.midrollPoints);
    player.vast._midrollPointsArr.sort();
  }

  function trackAdError(error, vastResponse) {
    player.trigger({type: 'vast.adError', error: error});
    cancelAds();
    logger.error ('AD ERROR:', error.message, error, vastResponse);
  }

  function isVPAID(vastResponse) {
    var i, len;
    var mediaFiles = vastResponse.mediaFiles;
    for (i = 0, len = mediaFiles.length; i < len; i++) {
      if (vastUtil.isVPAID(mediaFiles[i])) {
        return true;
      }
    }
    return false;
  }

  function runSpinner() {
    player.addClass('vpaid_error');
    playerUtils.once(player, ['vpaid.AdImpression', 'vpaid.AdPaused', 'vast.adBlockEnd'], stopSpinner);
  }

  function stopSpinner() {
    player.removeClass('vpaid_error');
  }

};
